import React from "react";
import styled from "styled-components";
const StyledPage = styled.div`
    &.main-tutorial-container {
        width: 100%;
        height: 519px;
        display: flex;
        gap: 28px;
        flex-wrap: wrap;
    }
    .grouped-div {
        width: 392px;
        height: 248px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .grouped-div.disabled {
        pointer-events: none;
    }
    .grouped-div.disabled .div-title,
    .grouped-div.disabled img {
        opacity: 0.2;
    }
    .div-container {
        height: 220px;
        background-color: rgb(30, 38, 49);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .div-container img {
        width: 392px;
        height: 215px;
        border-radius: 10px;
    }
    .div-container:hover {
        outline: 2px solid #ff9900;
    }
`;
export default function GridComponent({ data, handleAction }) {
    return (
        <StyledPage className="main-tutorial-container">
            {data.map((value, idx) => (
                <div className={`grouped-div ${value?.isDisabled ? "disabled" : ""}`} key={idx}>
                    <div
                        className="div-container"
                        onClick={() => {
                            if (value?.value) handleAction(value?.value);
                        }}>
                        {value?.backgroundImg && <img src={value?.backgroundImg} alt="Tutorial" style={value?.style} />}
                    </div>
                    <div className="div-title">{value?.title}</div>
                </div>
            ))}
        </StyledPage>
    );
}
